<template>
  <div class="pay">
    <div class="pay-top">
      <div class="paytitle">充值</div>
      <div @click="guanbi" class="guanbicss">
        <img src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png" alt="" />
      </div>
    </div>
    <div class="alertlibs">
      充值金额：
    </div>
    <div class="pay-center2">
      <div
        class="pay-center2_item"
        v-for="(item, index) in option"
        :key="index"
        @click="Danwei(index, item.money, item.longMoney)"
        :class="{ biankuang2: danwei == index }"
        style="cursor: pointer"
      >
        <div class="long_money" :class=" danwei == index?'activeSelects':''">{{ item.longMoney }}龙币</div>
        <div class="pay_money" :class=" danwei == index?'activeSelects':''">{{ item.money }}元</div>
        <img
          v-if="index == danwei"
          class="pay-center2-img"
          src="https://oss.ansongqiubo.com/assets/home/icon_xuanze@2x.png"
          alt=""
        />
      </div>
   <!--   <div class="define_pay" @click="dianjiZidingyi">
        <input
          @input="change"
          type="text"
          placeholder="请输入金额"
          v-model.number="money2"
        />
        <div class="alert_payname">元</div>
        <img
          v-if="zidingyi"
          class="pay-center2-img"
          src="https://oss.ansongqiubo.com/assets/home/icon_xuanze@2x.png"
          alt=""
        />
      </div> -->
    </div>
    <div class="payMethods">
      <div class="ptitles">支付方式:</div>
      <div class="zhifubaobox">
        <img src="/static/newcenter/payzhifubao.png" alt="" srcset="">
        <span>支付宝支付</span>
      </div>
    </div>
    <div class="shouldmoneys">
      <div class="ptitle">
        应付金额：
      </div>
      <div class="pmoneys" v-if="!zidingyi">
        {{ money}} <span>元</span>
      </div>
      <div class="pmoneys" v-else>
        {{ money2?money2:0}} <span>元</span>
      </div>

    </div>
    <div class="paySuvbmit">
      <div class="buttons" @click="goPays">
        {{payTime?'支付中···':'立即充值'}}
      </div>
    </div>
 <!--   <div class="pay-bottom">
      <div id="qrcode"></div>
      <div class="qrcode_title" v-show="moneys1">
        <span>扫码支付</span>
        <span class="qr_number">{{ money }}元</span>
      </div>
      <div v-show="moneys2" class="qrcode_title">
        <span>扫码支付</span><span class="qr_number">{{ money2 }}元</span>
      </div>
      <div class="discript_msg">
        <span>大额龙币人工充值送福利:</span>
        <span>微信号：longzhu51888</span>
      </div>
    </div> -->
  </div>
</template>
<script>
let time_str = null; // 定时器
import qs from "qs";
import QRCode from "qrcodejs2";
import {paymentAli,paymentresult} from '@/api/lz.js'
import moment from 'moment'
export default {
  props: ["qrcode_url"],
  inject: ["reload"],
  data() {
    return {
      zhifubao: true,
      weixin: false,
      danwei: 0,
      option: [
        {
          longMoney: "100",
          money: "10",
        },
        {
          longMoney: "500",
          money: "50",
        },
        {
          longMoney: "1000",
          money: "100",
        },
        {
          longMoney: "5000",
          money: "500",
        },
        {
          longMoney: "10000",
          money: "1000",
        },
        {
          longMoney: "50000",
          money: "5000",
        },
      ],
      money: 10, //充值金额
      longMoney: 500,
      qrcode: "",
      uid: "", //充值uid
      money2: null,
      moneys1: true,
      moneys2: false,
      zidingyi: false, //自定义输入金额
      payTime:false,
      PayTimeout:'',
    };
  },
  mounted() {
    this.initData()
  },
  methods: {
     goPays(){
      //支付方式ali_app=支付宝app,ali_qr=支付宝pc,ali_page=支付宝H5
      let p = '';
      if(this.zidingyi){
        p = this.money2
      }else{
        p = this.money
      }
      if(Number(p) <= 0){
        return this.$message.error('充值金额需大于0')
      }
      if(this.payTime){
        return this.$message.error('支付中请稍后重试')
      }
      console.log(this.uid,p,this.zidingyi);
      paymentAli({
        user_id: this.uid,
        amount:p,
        method:'ali_qr'
      }).then(result=>{
        if(result.data.code == 200){
          if (result.data.data && result.data.data.time_expire) {
            this.PayTimeout = moment(result.data.data.time_expire).valueOf();
            console.log('倒计时支付', this.PayTimeout);
          }
          this.awaitResult(result.data.data.out_trade_no);
          window.open(result.data.data.pay_info);
          console.log('result',result);
        }
      })
      this.payTime = true;
      setTimeout(()=>{
        this.payTime = false
      },1500)
    },
    maskClose(){
      this.guanbi()
    },
    async awaitResult(code) {
      let result = await paymentresult({
        method: "ali_qr",
        outTradeNo: code,
      });
      if (result.data.code == 200) {
        if (result.data.data.tradeStatus == "TRADE_SUCCESS") {
          this.$message.success("支付成功");
          console.log("支付成功.............", result.data.data.tradeStatus);
          this.maskClose();
          let resultMoeys = await this.$store.dispatch('getUserMoneyData',2);
          console.log('我余额数据', resultMoeys);
          this.reload();
          this.$emit('changeLoad','pay')
        } else {
          let curTime = moment().valueOf();
          console.log("等待支付结果........",curTime, result.data.data.tradeStatus,this.PayTimeout);
          if (curTime < this.PayTimeout || result.data.data.tradeStatus ==  "WAIT_BUYER_PAY") {
            setTimeout(() => {
              this.awaitResult(code);
            }, 1000);
          }else{
            this.maskClose();
            this.PayTimeout = ''
          }
        }
      } else {
        this.$message.success(result.data.message);
      }
    },
    async initData(){
      if(localStorage.getItem('token')){
        let user = await this.$store.dispatch('getUserInfoData');
        console.log('支付用户信息',user);
        if(user.lzid){
          this.uid = user.userInfo.uid;
        }
      }
    },
    dianjiZidingyi() {
      this.zidingyi = true;
      this.danwei = null;
    },
    change(value) {
      //接受input每次键入的value值
       var aaa = value.target.value.replace(/[^\d]/g,'');
        if (aaa > 50000) {
            this.money2 = 50000
        }else if (aaa <= 0) {
            this.money2 = "";
            return
        }else{
            this.money2 = aaa
        }
      //
      if (time_str) {
        clearTimeout(time_str);
      }

    },
    guanbi() {
      this.$emit("pay", false);
    },
    Danwei(e, money, longMoney) {
      this.zidingyi = false;
      this.danwei = e;
      this.danwei = e;
      this.money = money;
      this.longMoney = longMoney;
      this.moneys2 = false;
      this.moneys1 = true;
    },
    Zhifubao() {
      this.zhifubao = true;
      this.weixin = false;
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            return data;
          },
        ],
        url: this.payGateway + "/v1/payment/trade",
        method: "post",
        data: {
          user_id: this.uid,
          amount: this.money,
          desc: this.longMoney,
          method: "ali_adapay_qr",
          // method:"wx_qr"
        },
      }).then((res) => {
        console.log(res);
        this.qrcode._el.innerHTML = "";
        this.qrcode = new QRCode("qrcode", {
          width: 120,
          height: 120,
          text: res.data.data.qrcode_url,
          colorDark: "#000",
          colorLight: "#FFF",
        });
      });
    },
    Weixin() {
      this.zhifubao = false;
      this.weixin = true;
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            return data;
          },
        ],
        url: this.payGateway + "/v1/payment/trade",
        method: "post",
        data: {
          user_id: this.uid,
          amount: this.money,
          desc: this.longMoney,
          // method: "ali_adapay_qr"
          method: "wx_qr",
        },
      }).then((res) => {
        // console.log(res);
        this.qrcode._el.innerHTML = "";
        this.qrcode = new QRCode("qrcode", {
          width: 120,
          height: 120,
          text: res.data.data.code_url,
          colorDark: "#000",
          colorLight: "#FFF",
        });
      });
    },
  },
  created() {
    //   this.$watch('money2', debounce((newQuery) => {
    //               this.$emit('money2', newQuery)
    //     console.log(123);
    //   }, 200))
  },
  watch: {
    qrcode_url(val, newval) {
      console.log(val);

      this.qrcode = new QRCode("qrcode", {
        width: 120,
        height: 120,
        text: val,
        colorDark: "#000",
        colorLight: "#FFF",
      });
      // console.log(this.qrcode);
    },
  },
};
</script>

<style scoped lang='scss'>

.biankuang {
  border: 1px solid rgba(255, 135, 41, 1) !important;
}
.biankuang2 {
  border: 1px solid rgba(255, 135, 41, 1) !important;
}
.pay {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
  border-radius: 6px;
  padding: 20px 22px;
  box-sizing: border-box;
  width: 494px;
  .pay-center2 {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .define_pay {
      width: 140px;
      height: 76px;
      border-radius: 6px;
      border: 1px solid #b3b3b3;
      padding: 20px;
      box-sizing: border-box;
      position: relative;
      .alert_payname {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
      }
      input {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
    }
    .pay-center2_item {
      position: relative;
      width: 140px;
      height: 76px;
      margin: 0 10px 12px 0;
      border-radius: 6px;
      border: 1px solid #b3b3b3;
      display: flex;
      flex-flow: column wrap;
      align-items: center;
      justify-content: center;
      .activeSelects{
        color: rgba(255, 135, 41, 1) !important;
      }
      .long_money {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .pay_money {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
    .pay-center2_item:nth-child(3n) {
      margin-right: 0px !important;
    }
  }
  .alertlibs{
    margin-bottom: 12px;
    margin-top: 24px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .paySuvbmit{
    display: flex;
    margin-top: 40px;
    justify-content: center;
    .buttons{
      cursor: pointer;
      width: 98px;
      height: 36px;
      background: linear-gradient(270deg, #FFA829 0%, #FF8729 100%);
      border-radius: 18px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      line-height: 36px;
    }
  }
  .shouldmoneys{
    margin-top: 29px;
    display: flex;
    align-items: center;
   .ptitles{
     font-size: 16px;
     font-family: PingFangSC-Regular, PingFang SC;
     font-weight: 400;
     color: #333333;
     margin-right: 12px;
   }
    .pmoneys{
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FF8729;
      span{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
  }
  .payMethods{
    border-top: 1px solid #EBEEF3;;
    margin-top: 22px;
    display: flex;
    align-items: center;
    padding-top: 22px;
    .ptitles{
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-right: 12px;
    }
    .zhifubaobox{
      width: 122px;
      height: 32px;
      background: #1076E9;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }
      span{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }

  .pay-top {
    border-radius: 6px 6px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 22px;
    border-bottom: 1px solid #EBEEF3;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    position: relative;
    .guanbicss {
      position: absolute;
      right: 20px;
      height: 22px;
    }
    .guanbicss:hover {
      transform: rotate(180deg);
      cursor: pointer;
      transition: transform 0.5s ease;
    }
    .paytitle{
      text-align: center;
    }
  }
}

.pay-center1 {
  width: 503px;
  box-sizing: border-box;
  padding: 0 15px 0 10px;
  height: 45px;
  line-height: 45px;
}

.pay-center2 > div > input {
  width: 100%;
  height: 60%;
  background-color: white;
  border: none;
  border-radius: 12px;
  outline: none;
  color: #999999;
  box-sizing: border-box;
}
.pay-center2-img {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 32px;
  height: 32px;
}
.pay-center3 {
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
}
.pay-center4 {
  margin: 12px 0;
  .pay_item {
    width: 122px;
    height: 32px;
    border-radius: 6px;
    border: 1px solid #999999;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .icon_pay {
    width: 16px;
    height: 16px;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .pay_select_img {
    width: 20px;
    height: 20px;
  }
  .pay_select_name {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.pay-bottom {
  width: 454px;
  box-sizing: border-box;
  display: flex;
  .discript_msg {
    display: flex;
    flex-direction: column;
	align-items: flex-start;
	justify-content: flex-end;
    span:nth-child(1) {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  #qrcode {
    width: 122px;
    height: 122px;
  }
  .qrcode_title {
    margin-left: 12px;
    flex: 2;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    display: flex;
    padding-bottom: 12px;
    align-items: flex-end;
    .qr_number {
      color: #ff8729;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/component/Pay.vue